import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as PropostasAlertasActions } from "../ducks/propostasAlertas";
import { Creators as PropostasAlertas } from "../ducks/propostas";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as AlertActions } from "../ducks/alert";
import { Creators as SuccessActions } from "../ducks/success";
import moment from "moment";
import { formatReal } from "../../helpers";
import { Creators as ModalPrint } from "../ducks/modalPrint";

export function* getListPropostasAlertas() {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(api.get, `/sales/alert`);
    const { data: propostasAlertas, columns_settings } = data;
    /* GERAÇÃO DAS PROPOSTAS, MELHORAR ISSO UTILIZANDO DRY */
    let propostasAlertasPayload = [];
    const total = propostasAlertas.reduce((total, current) => {
      return total + current.sales_count;
    }, 0);
    const total_financed = 0;
    const total_released = 0;
    const total_base = 0;
    const total_receipted_total = 0;
    const total_estornado_total = 0;
    const total_comissioned_total = 0;
    const total_value_installment = 0;
    let total_comissions_predict = 0;
    propostasAlertasPayload = propostasAlertas.map((proposta) =>
      proposta.sales.map((sale) => ({
        id: sale.id,
        benefit_number: sale.benefit_number,
        created_at: sale.created_at
          ? `<span class="data-hora">${moment(sale.created_at).format(
              "DD/MM/YYYY"
            )} <small class="time-hour">${moment(sale.created_at).format(
              "H:mm"
            )}</small></span>`
          : "",
        date: sale.date ? moment(sale.date).format("DD/MM/YYYY") : "",
        accepted_at: sale.accepted_at
          ? moment(sale.accepted_at).format("DD/MM/YYYY")
          : "",
        date_paid: sale.date_paid
          ? moment(sale.date_paid).format("DD/MM/YYYY")
          : "",
        portability_date_paid: sale.portability_date_paid
          ? moment(sale.portability_date_paid).format("DD/MM/YYYY")
          : "",
        date_canceled: sale.date_canceled
          ? moment(sale.date_canceled).format("DD/MM/YYYY")
          : "",
        conclusion_date: sale.conclusion_date
          ? moment(sale.conclusion_date).format("DD/MM/YYYY")
          : "",
        user: proposta.name,
        store: sale.store.name,
        bank: sale.convenet
          ? sale.convenet.bank
            ? sale.convenet.bank.name
            : ""
          : "",
        promoter: sale.convenet
          ? sale.convenet.promoter
            ? sale.convenet.promoter.name
            : ""
          : "",
        product: sale.convenet
          ? sale.convenet.product
            ? sale.convenet.product.name
            : ""
          : "",
        operation: sale.convenet
          ? sale.convenet.operation
            ? sale.convenet.operation.name
            : ""
          : "",
        convenet: sale.convenet ? sale.convenet.name : "",
        contract_number: sale.contract_number,
        customer: sale.customer.name,
        customer_cpf: sale.customer.cpf_cnpj,
        customer_id: sale.customer.id,
        value_financed: sale.value_financed
          ? formatReal(sale.value_financed)
          : "",
        value_released: sale.value_released
          ? formatReal(sale.value_released)
          : "",
        value_debit: sale.value_debit ? formatReal(sale.value_debit) : "",
        value_base_total: sale.value_base_total
          ? formatReal(sale.value_base_total)
          : "",
        total_receipted: sale.total_receipted
          ? formatReal(sale.total_receipted)
          : "",
        total_estornado: sale.total_estornado
          ? formatReal(sale.total_estornado)
          : "",
        total_comissioned: sale.total_comissioned
          ? formatReal(sale.total_comissioned)
          : "",
        receipt_predict: sale.receipt_predict
          ? formatReal(sale.receipt_predict)
          : "0,00",
        comissions_predict: `
          <span class="timer">
            <span class='tag-child'>
              ${sale.comissions_predict
                .map(
                  (comission) =>
                    `<span class="tag-row"><span>${
                      comission.faixa
                    }:</span><span>${formatReal(comission.value)}</span></span>`
                )
                .join("")}
            </span>
            ${formatReal(
              sale.comissions_predict.reduce((total, current) => {
                total_comissions_predict =
                  total_comissions_predict +
                  current.value / sale.comissions_predict.length;
                return total + current.value;
              }, 0) / sale.comissions_predict.length
            )}
          </span>`,
        deadline: sale.deadline,
        value_installment: sale.value_installment
          ? formatReal(sale.value_installment)
          : "",
        status: sale.status[0]
          ? `<span class="td-color" style="color: #ffffff!important; cursor:pointer; background-color:${
              sale.status[0].color
            }">
          ${
            sale.last_status_notes
              ? `<span class="tag-child">
          <span class="tag-row">${sale.last_status_notes}</span>
        </span>`
              : ""
          }
            ${sale.status[0].name}
          </span>`
          : "",
        last_status: sale.status[0]
          ? `<span class="lowercase timer">
            <span class='tag-child'>
              <span class='tag-row'>
                Último status por:&nbsp;<b>${sale.last_status_user}</b>
              </span>
            </span>
            ${moment(
              moment(sale.status_updated_at).format("DD/MM/YYYY H:mm:ss"),
              "DD/MM/YYYY H:mm:ss"
            ).fromNow()}
        </span>`
          : "",
        docs:
          sale.notes && !sale.docs
            ? `<span class="s-docs docs-not-ok-warning"><span class='tag-child'><span class='tag-row'>Observações: ${
                sale.notes
              }</span></span>
              ${
                sale.count_sale_files <= 0 && sale.count_customer_files <= 0
                  ? '<i class="fa fa-folder-o fa-lg" />'
                  : '<i class="fa fa-folder fa-lg has-files" />'
              }
              </span>`
            : sale.docs
            ? `<span class="s-docs docs-ok"><span class='tag-child'><span class='tag-row'>Documentação Ok</span></span>${
                sale.count_sale_files <= 0 && sale.count_customer_files <= 0
                  ? '<i class="fa fa-folder-o fa-lg" />'
                  : '<i class="fa fa-folder fa-lg has-files" />'
              }</span>`
            : `<span class="s-docs docs-not-ok">${
                sale.count_sale_files <= 0 && sale.count_customer_files <= 0
                  ? '<i class="fa fa-folder-o fa-lg" />'
                  : '<i class="fa fa-folder fa-lg has-files" />'
              }</span>`,
        sum_values: sale.sum_values,
        edit_status: sale.status[0] ? sale.status[0].adm_change : 0,
      }))
    );
    yield put(
      PropostasAlertasActions.getListPropostasAlertasSuccess(
        propostasAlertas,
        total,
        total_financed,
        total_released,
        total_base,
        total_receipted_total,
        total_estornado_total,
        total_comissioned_total,
        total_value_installment,
        columns_settings,
        propostasAlertasPayload
      )
    );
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getPropostasAlertas({ payload }) {
  try {
    yield put(PropostasAlertas.getPropostas(payload.id));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* printAlertas({ payload }) {
  try {
    const { data: url } = yield call(api.get, `/sales/${payload.id}/pdf`);
    yield put(PropostasAlertasActions.printSuccess(url.pdf));
    yield put(ModalPrint.openPrintModal());
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* getPropostasAlertasCount() {
  try {
    const { data } = yield call(api.get, `/sales/alert/count`);
    yield put(PropostasAlertasActions.getPropostasAlertasCountSuccess(data));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
}

export function* deletePropostasAlertas() {
  try {
    yield put(LoadingActions.setLoading());
    const { id } = yield select((state) => state.propostas.item);
    yield call(api.delete, `/sales/${id}`);
    yield put(PropostasAlertasActions.getListPropostasAlertas());
    yield put(SuccessActions.openSuccess("Proposta excluída com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map((err) => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/propostasAlertas.js